module.exports = __webpack_public_path__ + "img/sovendus.58f56d47.png";